export default __webpack_public_path__ + "static/graphik-web-medium-94fb0b983f194b42c9b8bc81ae1a25fb.woff2";